module Easypass {
    class CreditErrorCallbackController {

    }

    angular.module('easypass').controller('creditErrorCallbackController', [CreditErrorCallbackController]);
}